module.exports = __webpack_public_path__ + "static/media/web-element.38f91684.jpg";